import { DataLineageNodeTypes } from '@y42/json-schema';
import * as go from 'gojs';
import { defaultGroupTemplate } from './group/default-group';
import { defaultLinkTemplate } from './link/default-link';
import { defaultNodeTemplate } from './node/default-node';
import { emptyNodeTemplate } from './node/empty-node';
import { widgetNodeTemplate } from './node/widget-node';

export const createGroupTemplateMap = () => {
  const templateMap = new go.Map<string, go.Group>();

  // Default
  templateMap.add('', defaultGroupTemplate());

  return templateMap;
};

export const createNodeTemplateMap = () => {
  const templateMap = new go.Map<string, go.Node>();

  // Default
  templateMap.add('', defaultNodeTemplate());
  templateMap.add(DataLineageNodeTypes.Empty, emptyNodeTemplate());
  templateMap.add(DataLineageNodeTypes.Widget, widgetNodeTemplate());

  return templateMap;
};

export const createLinkTemplateMap = () => {
  const templateMap = new go.Map<string, go.Link>();

  // Default
  templateMap.add('', defaultLinkTemplate());

  return templateMap;
};
